import { getLocalStorageItem } from "./LocalStorage";

export const getToken = () => {
    return {
      headers: {
        "x-auth-token": getLocalStorageItem(),
      },
    };
  };